/**
 * Helper centralizzato per caricare la griglia dei subprojects via AJAX
 * 
 * Questo helper gestisce:
 * - Caricamento della griglia via AJAX
 * - Estrazione ed esecuzione degli script dalla risposta
 * - Estrazione ed inserimento degli stili nel <head> del documento
 * - Reinizializzazione corretta della griglia
 * 
 * Utilizzo:
 *   SubprojectsGridLoader.load(projectId, containerSelector, options)
 * 
 * Esempio:
 *   SubprojectsGridLoader.load(649, '#tasks-container', {
 *     onSuccess: function() { console.log('Griglia caricata!'); },
 *     onError: function(error) { console.error('Errore:', error); }
 *   })
 */

window.SubprojectsGridLoader = (function() {
    'use strict';

    /**
     * Carica la griglia dei subprojects via AJAX
     * 
     * @param {number} projectId - ID del progetto
     * @param {string} containerSelector - Selettore jQuery del container dove inserire la griglia
     * @param {object} options - Opzioni di configurazione
     * @param {function} options.onSuccess - Callback chiamato quando la griglia è caricata con successo
     * @param {function} options.onError - Callback chiamato in caso di errore
     * @param {string} options.loadingHtml - HTML da mostrare durante il caricamento
     */
    function load(projectId, containerSelector, options) {
        options = options || {};
        
        const $container = $(containerSelector);
        
        if ($container.length === 0) {
            console.error('SubprojectsGridLoader: Container non trovato:', containerSelector);
            if (options.onError) {
                options.onError('Container non trovato');
            }
            return;
        }

        // Mostra loading indicator
        const loadingHtml = options.loadingHtml || '<div style="text-align: center; padding: 40px;"><i class="fa fa-spinner fa-spin" style="font-size: 24px; color: #3c8dbc;"></i><p style="margin-top: 15px; color: #666;">Caricamento griglia task...</p></div>';
        $container.html(loadingHtml);

        // Costruisci URL - usa window.subprojectsGridUrl se disponibile (passato dalla view Blade)
        // altrimenti usa l'URL hardcoded
        // Aggiungi parametro my_brain=1 se viene chiamato da my-brain
        const isMyBrain = options.myBrainMode || false;
        const baseUrl = window.subprojectsGridUrl || '/admin/subprojects/grid';
        const url = `${baseUrl}/${projectId}${isMyBrain ? '?my_brain=1' : ''}`;
        
        // Carica la griglia tramite AJAX
        $.ajax({
            url: url,
            method: 'GET',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(html) {
                try {
                    // Estrai gli script dalla risposta HTML
                    const scripts = extractScripts(html);
                    console.log('SubprojectsGridLoader: Script estratti:', scripts.length);
                    scripts.forEach(function(script, index) {
                        console.log('SubprojectsGridLoader: Script', index + 1, '- src:', script.src || 'inline', '- text length:', script.text ? script.text.length : 0);
                    });
                    
                    // Estrai gli stili dalla risposta HTML
                    const styles = extractStyles(html);
                    console.log('SubprojectsGridLoader: Stili estratti:', styles.length);
                    
                    // Rimuovi script e stili dall'HTML prima di inserirlo
                    let htmlWithoutScriptsAndStyles = removeScripts(html);
                    htmlWithoutScriptsAndStyles = removeStyles(htmlWithoutScriptsAndStyles);
                    
                    // Aggiungi v-cloak al container per evitare che Vue compili il contenuto
                    $container.attr('v-cloak', '');
                    
                    // Marca che siamo in un contesto AJAX per evitare inizializzazione automatica
                    window.subprojectsGridAjaxLoad = true;
                    
                    // Inserisci gli stili nel <head> prima di inserire l'HTML
                    insertStyles(styles);
                    
                    // Inserisci l'HTML senza script e stili
                    $container.html(htmlWithoutScriptsAndStyles);
                    
                    // Esegui gli script estratti
                    executeScripts(scripts, function() {
                        // Reinizializza la griglia dopo che gli script sono stati eseguiti
                        reinitializeGrid();
                        
                        // Rimuovi v-cloak dopo che tutto è stato inizializzato
                        setTimeout(function() {
                            $container.removeAttr('v-cloak');
                            // Rimuovi il flag AJAX dopo l'inizializzazione
                            window.subprojectsGridAjaxLoad = false;
                        }, 100);
                        
                        // Callback di successo
                        if (options.onSuccess) {
                            options.onSuccess();
                        }
                    });
                } catch (error) {
                    console.error('SubprojectsGridLoader: Errore durante l\'elaborazione della risposta:', error);
                    $container.html('<div style="text-align: center; padding: 40px; color: #d9534f;"><i class="fa fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 15px;"></i><p>Errore durante il caricamento della griglia</p></div>');
                    if (options.onError) {
                        options.onError(error);
                    }
                }
            },
            error: function(xhr, status, error) {
                console.error('SubprojectsGridLoader: Errore AJAX:', status, error);
                
                let errorMsg = 'Errore nel caricamento della griglia task';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    errorMsg = xhr.responseJSON.error;
                } else if (xhr.status === 403) {
                    errorMsg = 'Non hai i permessi per visualizzare i task di questo progetto';
                } else if (xhr.status === 404) {
                    errorMsg = 'Progetto non trovato';
                }
                
                $container.html('<div style="text-align: center; padding: 40px; color: #d9534f;"><i class="fa fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 15px;"></i><p>' + errorMsg + '</p></div>');
                
                if (options.onError) {
                    options.onError(error);
                }
            }
        });
    }

    /**
     * Estrae tutti gli script dalla risposta HTML
     * 
     * @param {string} html - HTML contenente gli script
     * @returns {Array} Array di oggetti script
     */
    function extractScripts(html) {
        const scripts = [];
        const tempDiv = $('<div>').html(html);
        
        tempDiv.find('script').each(function() {
            const script = {
                src: $(this).attr('src'),
                text: $(this).html() || $(this).text() || '',
                type: $(this).attr('type') || 'text/javascript'
            };
            scripts.push(script);
        });
        
        return scripts;
    }

    /**
     * Rimuove tutti gli script dall'HTML
     * 
     * @param {string} html - HTML contenente gli script
     * @returns {string} HTML senza script
     */
    function removeScripts(html) {
        const tempDiv = $('<div>').html(html);
        tempDiv.find('script').remove();
        return tempDiv.html();
    }

    /**
     * Estrae tutti gli stili dalla risposta HTML
     * 
     * @param {string} html - HTML contenente gli stili
     * @returns {Array} Array di oggetti style
     */
    function extractStyles(html) {
        const styles = [];
        const tempDiv = $('<div>').html(html);
        
        tempDiv.find('style').each(function() {
            const style = {
                text: $(this).html() || $(this).text() || '',
                type: $(this).attr('type') || 'text/css'
            };
            styles.push(style);
        });
        
        return styles;
    }

    /**
     * Rimuove tutti gli stili dall'HTML
     * 
     * @param {string} html - HTML contenente gli stili
     * @returns {string} HTML senza stili
     */
    function removeStyles(html) {
        const tempDiv = $('<div>').html(html);
        tempDiv.find('style').remove();
        return tempDiv.html();
    }

    /**
     * Inserisce gli stili estratti nel <head> del documento
     * 
     * @param {Array} styles - Array di oggetti style
     */
    function insertStyles(styles) {
        styles.forEach(function(styleObj, index) {
            // Crea un ID univoco per lo stile per evitare duplicati
            const styleId = 'subprojects-grid-style-' + Date.now() + '-' + index;
            
            // Verifica se lo stile è già stato inserito
            if (document.getElementById(styleId)) {
                return; // Salta se già presente
            }
            
            const style = document.createElement('style');
            style.id = styleId;
            style.type = styleObj.type || 'text/css';
            style.textContent = styleObj.text;
            
            document.head.appendChild(style);
        });
    }

    /**
     * Esegue gli script estratti in sequenza
     * 
     * @param {Array} scripts - Array di oggetti script
     * @param {function} callback - Callback chiamato quando tutti gli script sono stati eseguiti
     */
    function executeScripts(scripts, callback) {
        if (scripts.length === 0) {
            if (callback) callback();
            return;
        }

        let scriptIndex = 0;
        
        function executeNext() {
            if (scriptIndex >= scripts.length) {
                if (callback) callback();
                return;
            }

            const scriptObj = scripts[scriptIndex];
            
            if (scriptObj.src) {
                // Script esterno - carica normalmente
                const script = document.createElement('script');
                script.type = scriptObj.type || 'text/javascript';
                script.src = scriptObj.src;
                script.onload = function() {
                    scriptIndex++;
                    executeNext();
                };
                script.onerror = function() {
                    console.warn('SubprojectsGridLoader: Errore nel caricamento script esterno:', scriptObj.src);
                    scriptIndex++;
                    executeNext();
                };
                document.head.appendChild(script);
            } else {
                // Script inline - esegui direttamente con eval invece di inserire nel DOM
                // Questo evita che Vue.js provi a compilare gli script
                try {
                    
                    // Pulisci il contenuto dello script rimuovendo eventuali tag HTML o commenti Blade non processati
                    let cleanedText = scriptObj.text;
                    
                    // Rimuovi eventuali tag HTML o commenti Blade che potrebbero essere stati inclusi
                    cleanedText = cleanedText.replace(/<!--.*?-->/g, ''); // Rimuovi commenti HTML
                    cleanedText = cleanedText.replace(/@php[\s\S]*?@endphp/g, ''); // Rimuovi blocchi @php non processati
                    cleanedText = cleanedText.trim();
                    
                    // Verifica se il contenuto inizia con '<' (potrebbe essere HTML non processato)
                    if (cleanedText.startsWith('<')) {
                        console.error('SubprojectsGridLoader: ⚠️ Il contenuto dello script inizia con "<" - potrebbe essere HTML non processato');
                        console.error('SubprojectsGridLoader: Contenuto script (primi 500 caratteri):', cleanedText.substring(0, 500));
                        scriptIndex++;
                        executeNext();
                        return;
                    }
                    
                    // Usa Function constructor invece di eval per maggiore sicurezza
                    // Usa waitForjQuery per aspettare che jQuery sia disponibile prima di eseguire
                    // Helper standardizzato per jQuery readiness - Pattern utilizzato nel progetto
                    function waitForjQuery(callback, attempts = 0) {
                        const maxAttempts = 100; // 10 secondi massimi
                        
                        if (typeof window.jQuery === 'undefined' || typeof window.$ === 'undefined') {
                            if (attempts < maxAttempts) {
                                setTimeout(() => waitForjQuery(callback, attempts + 1), 100);
                            } else {
                                console.error('SubprojectsGridLoader: jQuery non disponibile dopo ' + maxAttempts + ' tentativi, salto esecuzione script inline', scriptIndex + 1);
                                scriptIndex++;
                                executeNext();
                            }
                            return;
                        }
                        
                        callback();
                    }
                    
                    // Aspetta che jQuery sia disponibile prima di eseguire lo script
                    waitForjQuery(function() {
                        try {
                            // Assicurati che $ e jQuery siano disponibili nel contesto globale prima di eseguire
                            if (typeof window.$ === 'undefined' && typeof window.jQuery !== 'undefined') {
                                window.$ = window.jQuery;
                            }
                            if (typeof window.jQuery === 'undefined' && typeof window.$ !== 'undefined') {
                                window.jQuery = window.$;
                            }
                            
                            // Esegui il codice direttamente usando eval invece di new Function
                            // Questo evita problemi di sintassi quando il codice contiene definizioni di funzione
                            // Il codice viene eseguito nel contesto globale, quindi le funzioni definite saranno disponibili globalmente
                            eval(cleanedText);
                            scriptIndex++;
                            executeNext();
                        } catch (e) {
                            console.error('SubprojectsGridLoader: ❌ Errore nell\'esecuzione script inline', scriptIndex + 1, ':', e);
                            console.error('SubprojectsGridLoader: Contenuto script (primi 500 caratteri):', scriptObj.text.substring(0, 500));
                            scriptIndex++;
                            executeNext();
                        }
                    });
                } catch (e) {
                    console.error('SubprojectsGridLoader: ❌ Errore nell\'esecuzione script inline', scriptIndex + 1, ':', e);
                    console.error('SubprojectsGridLoader: Contenuto script (primi 500 caratteri):', scriptObj.text.substring(0, 500));
                    scriptIndex++;
                    executeNext();
                }
            }
        }

        executeNext();
    }

    /**
     * Reinizializza la griglia dopo il caricamento via AJAX
     */
    function reinitializeGrid() {
        // Evita chiamate multiple
        if (window.subprojectsGridReinitializing) {
            return;
        }
        window.subprojectsGridReinitializing = true;
        
        // Aspetta un po' per assicurarsi che tutto sia caricato
        // Usa un polling per verificare che le funzioni siano disponibili
        let attempts = 0;
        const maxAttempts = 20; // Massimo 2 secondi (20 * 100ms)
        
        function tryReinitialize() {
            attempts++;
            
            // Resetta il flag di inizializzazione per permettere la reinizializzazione
            if (typeof window.subprojectsGridInitialized !== 'undefined') {
                window.subprojectsGridInitialized = false;
            }
            
            // Resetta anche il flag delle funzioni inizializzate
            if (typeof window.subprojectsGridFunctionsInitialized !== 'undefined') {
                window.subprojectsGridFunctionsInitialized = false;
            }
            
            // Verifica se le funzioni sono disponibili
            if (typeof window.initializeSubprojectsGridJQueryCode === 'function') {
                try {
                    window.initializeSubprojectsGridJQueryCode(0, true); // Passa true per forzare reinizializzazione
                    
                    // Rimuovi il flag dopo un delay per permettere future reinizializzazioni
                    setTimeout(function() {
                        window.subprojectsGridReinitializing = false;
                    }, 1000);
                } catch (e) {
                    console.error('SubprojectsGridLoader: ❌ Errore nella reinizializzazione griglia:', e);
                    window.subprojectsGridReinitializing = false;
                }
            } else if (attempts < maxAttempts) {
                // Funzione non ancora disponibile, riprova dopo 100ms
                setTimeout(tryReinitialize, 100);
            } else {
                // Funzione non disponibile dopo tutti i tentativi
                console.error('SubprojectsGridLoader: ❌ initializeSubprojectsGridJQueryCode non disponibile dopo', maxAttempts, 'tentativi');
                console.error('SubprojectsGridLoader: Verifica che gli script della griglia siano stati eseguiti correttamente');
                window.subprojectsGridReinitializing = false;
            }
        }
        
        // Inizia il polling dopo un breve delay iniziale
        setTimeout(tryReinitialize, 200);
    }

    // API pubblica
    return {
        load: load
    };
})();

